// ProtectedRoute.js
import React, {useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';

export const ProtectedRoute = ():JSX.Element => {
  const auth = useAuth();
  return  (auth.isAuthenticated) ? <Outlet />: <Navigate to="/" />
};
